<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Stores / Branches</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>

          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn color="primary" small to="/new-store">
              <v-icon left dark>mdi-plus</v-icon>New Store / Branch
            </v-btn>
          </v-col>

          

          <!-- <v-col cols="12" xs="12" sm="12" md="6" v-show="IsDistributor == 'N'">
            <v-btn color="accent" text @click="storesDialog = true" class="float-right">
              <v-icon left>mdi-upload</v-icon>Import Stores / Branches
            </v-btn>
          </v-col> -->

          <v-col cols="12" xs="12" sm="12" md="6" v-show="IsDistributor == 'Y'">
            <v-btn color="accent" text @click="superStoresDialog = true" class="float-right">
              <v-icon left>mdi-upload</v-icon>Import Branches / Stores
            </v-btn>
          </v-col>
       

        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="stores" :search="search" :items-per-page="200">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/store/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- target template -->
              <template v-slot:item.monthlySalesTarget="{ item }">
                <span>{{ item.monthlySalesTarget | currency }}</span>
              </template>
              <!-- end -->

               <!-- target template -->
               <template v-slot:item.priceList="{ item }">
                <span>{{ item.priceList.Name }}</span>
              </template>
              <!-- end -->

              <!-- link -->
              <template v-slot:item.regLink="{ item }">
                <span>https://stalispos.softcloudtech.co.ke/register/{{item.storeTag}}</span>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- customers dialog -->
          <v-dialog v-model="storesDialog" max-width="650px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Import Stores</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="storesDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col xs="12" sm="12" md="6" cols="12">
                      <v-file-input
                        name="storesExcelFile"
                        v-model="excelFile"
                        label="Browse Excel Sheet"
                        outlined
                        dense
                      ></v-file-input>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="accent" @click="uploadExcel" :loading="loader">
                        <v-icon left>mdi-upload</v-icon>Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>

        <v-row>
          <!-- customers dialog -->
          <v-dialog v-model="superStoresDialog" max-width="850px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Import Stores</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="superStoresDialog= false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        autocomplete="off"
                        dense
                        outlined
                        v-model="selectedCustomer"
                        :items="customers"
                        label="Select Customer"
                        item-text="Name"
                        item-value="id"
                        :search-input.sync="searchCustomers"
                        @change="getBranches(selectedCustomer)"
                      ></v-autocomplete>
                    </v-col>

                    <v-col xs="12" sm="12" md="6" cols="12">
                      <v-file-input
                        name="storesExcelFile"
                        v-model="excelFile"
                        label="Browse Excel Sheet"
                        outlined
                        dense
                      ></v-file-input>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="accent" @click="uploadSuperExcel" :loading="loader">
                        <v-icon left>mdi-upload</v-icon>Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    IsDistributor() {
      return localStorage.getItem("IsDistributor");
    }
  },
  data: () => ({
    search: "",
    loader: false,
    selectedCustomer: null,
    customers: [],
    storesDialog: false,
    superStoresDialog: false,
    searchCustomers: null,
    excelFile: null,
    headers: [
      { text: "Customer", value: "customer.Name" },
      { text: "Branch / Store", value: "Name" },
      { text: "Region", value: "region.Name" },
      { text: "Sales Rep", value: "salesRep.name" },
      { text: "Price List", value: "priceList" },
      { text: "Monthly Sales Target", value: "monthlySalesTarget" },
      { text: "Action", value: "action" }
    ],
    stores: []
  }),
  watch: {
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    uploadExcel() {
      this.loader = true;
      const formData = new FormData();
      formData.append("storesExcelFile", this.excelFile);
      this.$store
        .dispatch("post", {
          url: `/stores/import`,
          data: formData
        })
        .then(res => {
          if (res.ResultCode == 1200) {
            this.$refs.snackbar.show(res.msg, "green");
            this.storesDialog = false;
            this.getStores();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          this.loader = false;
        });
    },
    uploadSuperExcel() {
      if(this.selectedCustomer == undefined || this.selectedCustomer == null) {
        this.$refs.snackbar.show(`Please select customer first !`, "red");
        return;
      }

      this.loader = true;
      var subscriber_id = localStorage.getItem("subscriber_id");
      const self = this;
      const formData = new FormData();
      formData.append("storesExcelFile", this.excelFile);
      formData.append("subscriber_id", parseInt(subscriber_id));
      formData.append("customer_id", parseInt(self.selectedCustomer));
      this.$store
        .dispatch("post", {
          url: `/supermarket-stores-import`,
          data: formData
        })
        .then(res => {
          if (res.ResultCode == 1200) {
            this.$refs.snackbar.show(res.msg, "green");
            this.superStoresDialog = false;
            this.getStores();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          this.loader = false;
        });
    }
  },
  created() {
    this.getStores();
  }
};
</script>